<template>
  <div class="dashboard-container">
    <div class="mb-2 page-title">
      <i class="bi bi-file-earmark-text"></i> Daftar Menu Navigasi
    </div>

    <div class="mb-2 d-flex justify-content-between align-items-center">
      <!-- Search Bar -->
      <DataToolbar
        v-model="searchQuery"
        placeholder="Cari..."
        :mencari="loading"
        @search="searchMenus"
      />

      

      <!-- Create Menu Button -->
      <router-link to="/admin/navigation/create" class="button button-primary">
        <i class="bi bi-plus-square"></i> Tambah Menu
      </router-link>
    </div>


    <!-- Table to display navigation data -->
    <div class="table-responsive mt-3">
      <table class="table mb-0">
        <thead>
          <tr>
            <th>No</th>
            <th>Nama</th>
            <th>Tipe</th>
            <th>Aksi</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="menu in menus.data" :key="menu.id">
            <td class="number-column">{{ menu.id }}</td>
            <td>{{ menu.name }}</td>
            <td>{{ menu.type }}</td>
            <td class="action-column">
              <div class="d-flex gap-2 justify-content-end">
          <MenuAksi v-slot="{ tutup }">
            <button type="button" class="aksi__item"
                    @click="tutup(); editMenu(menu.id)">
              <i class="bi bi-pencil-square"></i> Ubah
            </button>
            <button type="button" class="aksi__item aksi__item--bahaya"
                    @click="tutup(); deleteMenu(menu.id)">
              <i class="bi bi-trash"></i> Hapus
            </button>
          </MenuAksi>
        </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Pagination Controls -->
    <div class="d-flex justify-content-end mt-4">
      <AppPagination
        :current-page="currentPage"
        :total-pages="totalPages"
        @change-page="changePage"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/config/api";
import MenuAksi from "@/components/ui/MenuAksi.vue";
import DataToolbar from "@/components/ui/DataToolbar.vue";
import AppPagination from "@/components/ui/AppPagination.vue";

axios.defaults.baseURL = API.API_BASE_URL;

export default {
  name: "NavigationList",

  components: { MenuAksi, DataToolbar, AppPagination },
  data() {
    return {
      menus: { data: [] }, // Store paginated menu data here
      currentPage: 1, // Current page in pagination
      totalPages: 1, // Total number of pages
      perPage: 10, // Records per page
      searchQuery: "", // Store search query
    };
  },
  mounted() {
    this.loadNavigationMenus(); // Load menu data when the component is mounted
  },
  methods: {
    async loadNavigationMenus(page = 1) {
      try {
        const response = await axios.get("/navigation-menus", {
          params: {
            page: page,
            perPage: this.perPage,
            search: this.searchQuery, // Include search query in the request
            },
          });

        if (response.data) {
          this.menus = response.data; // Store paginated data
          this.currentPage = response.data.current_page; // Update current page
          this.totalPages = response.data.total_pages; // Update total number of pages
        }
      } catch (error) {
        console.error("Error loading menus:", error);
      }
    },

    changePage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.loadNavigationMenus(page); // Load data for the new page
      }
    },

    searchMenus(teks) {
      if (typeof teks === "string") this.searchQuery = teks;
      this.loadNavigationMenus(); // Fetch data again when the search query changes
    },

    async editMenu(id) {
      this.$router.push({ name: "EditMenu", params: { id } });
    },

    deleteMenu(id) {
      // Implement logic to delete the menu (e.g., API call)

      // Parameter dipertahankan untuk saat fungsi ini diimplementasikan.

      void id;
    },
  },
};
</script>

<style scoped>

.table th,
.table td {
  padding: 10px;
}




.pagination button {
  padding: 5px 10px;
  cursor: pointer;
  margin: 0 10px;
}

.form-control {
  width: 250px;
}
</style>
